import React from 'react';
import { Grid } from '@material-ui/core';
import { SettingsLayout } from '@backstage/plugin-user-settings';
import CredentialsCard from '../CredentialsCard/CredentialsCard';
import { UserSettingsInfoCard } from '../UserSettingsInfoCard/UserSettingsInfoCard';

// Main export
export default (
  <SettingsLayout>
    <SettingsLayout.Route path="general" title="General">
      <Grid container direction="row" spacing={3}>
        <Grid item xs={12}>
          <UserSettingsInfoCard />
        </Grid>
      </Grid>
    </SettingsLayout.Route>

    <SettingsLayout.Route path="client-credentials" title="Client credentials">
      <Grid item xs={12} md={6}>
        <CredentialsCard />
      </Grid>
    </SettingsLayout.Route>
  </SettingsLayout>
);
